import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import {
  formatDate,
  FormatWidth,
  getLocaleDateFormat,
  getLocaleFirstDayOfWeek,
} from '@angular/common';
import { parse } from 'date-fns';

export function dateToUtc(date: Date): Date {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )
  );
}

@Injectable()
export class LocaleDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek() {
    return getLocaleFirstDayOfWeek(this.locale);
  }

  format(date: Date, displayFormat: Object): string {
    return formatDate(
      date,
      getLocaleDateFormat(this.locale, FormatWidth.Medium),
      this.locale
    );
  }

  parse(value: any): Date | null {
    const date =
      parse(
        value,
        getLocaleDateFormat(this.locale, FormatWidth.Medium),
        new Date()
      ) ?? null;
    if (date == null) {
      return null;
    } else {
      return dateToUtc(date);
    }
  }
}
